import React, { Component } from 'react'

const AsyncComponent = importComponent => {
  return class asyncComponent extends Component {
    state = {
      component: null
    }
    componentDidMount() {
      importComponent().then(res => {
        this.setState({ component: res.default })
      })
    }

    render() {
      const Component = this.state.component
      return Component ? <Component {...this.props} /> : null
    }
  }
}

export default AsyncComponent



// WEBPACK FOOTER //
// ./src/component/asyncComponent.js